import { render, staticRenderFns } from "./FormTotalAmount.vue?vue&type=template&id=b7d68b5e&scoped=true&"
import script from "./FormTotalAmount.vue?vue&type=script&lang=js&"
export * from "./FormTotalAmount.vue?vue&type=script&lang=js&"
import style0 from "./FormTotalAmount.vue?vue&type=style&index=0&id=b7d68b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d68b5e",
  null
  
)

export default component.exports